import React, { useState, useEffect } from "react";
import ContentLoader from "react-content-loader";
import Tooltip from '@tippyjs/react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

import { getTrans as t } from "../../Localization/translations";
import ACHproviderService from "../../services/ACHproviders/ACHproviderServices";

function ViewAchProvider() {
    const [provider, setProvider] = useState({});
    const [loading, setLoading] = useState(true);

    const { state } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        ACHproviderService.getACHprovider(state)
            .then(response => {
                const data = response.data
                    ? response.data.response
                    : response.response
                        ? response.response
                        : response;
                setProvider(data || {});
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [state, navigate]);


    return (
        <div className="container-fluid">
            <ToastContainer />
            {loading ? (
                <ContentLoader
                    viewBox="0 0 400 160"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                >
                    <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                    <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                    <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                    <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                </ContentLoader>
            ) : (
                <>
                    <div className="header pb-0 ">
                        <div className="d-lg-flex pt-2">
                            <div>
                                <h5>{t('ACH Provider Details')}</h5>
                                <h6>
                                    <Link to="/achproviders" className="tc">{t("ACH Providers")}</Link> / <span>{t("View ACH Provider")}</span>
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className="card ">
                        <div className="card-body">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('ACH Operator Name')}{" "}
                                            <Tooltip content={t("ACHOperatorname_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.ach_operator_name || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Immediate Destination')}{" "}
                                            <Tooltip content={t("immediate_destination_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.immediate_destination || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Immediate Destination Name')}{" "}
                                            <Tooltip content={t("Immediatedestname_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.immediate_destination_name || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Immediate Origin')}{" "}
                                            <Tooltip content={t("immediate_origin_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.immediate_origin || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Immediate Origin Name')}{" "}
                                            <Tooltip content={t("immediate_origin_name_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.immediate_origin_name || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Company Identification')}{" "}
                                            <Tooltip content={t("CompanyIdentification_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.company_identification || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Standard Entry Class Code')}{" "}
                                            <Tooltip content={t("StandardEntryClassCode_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.standard_entry_class_code || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Originating BANK FID')}{" "}
                                            <Tooltip content={t("OriginatingBankFID_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.originating_bank_fid || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Originator Tax ID')}{" "}
                                            <Tooltip content={t("OriginatorTaxID_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.originator_tax_id || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Destination')}{" "}
                                            <Tooltip content={t("Destination_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.destination || "None"}
                                        </span>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Destination Name')}{" "}
                                            <Tooltip content={t("DestinationName_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.destination_name || "None"}
                                        </span>
                                    </div>
                                    <div className="col-xl-3">
                                        <label className="col-lg-12 col-form-label">
                                            {t('Service Class Code')}{" "}
                                            <Tooltip content={t("ServiceClassCode_Tooltip")}>
                                                <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                        </label>
                                    </div>
                                    <div className="col-xl-3">
                                        <span className="col-lg-8 view-label p">
                                            {provider.service_class_code || "None"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default ViewAchProvider;